import { Conditional } from '../conditional';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import styles from './styles.module.scss';

interface ExpanderProps {
  isExpanded: boolean;
  onExpandHandler: () => void;
  className?: string;
}

export const Expander = ({
  isExpanded,
  onExpandHandler,
  className
}: ExpanderProps) => {
  const chevronUpIcon = (
    <CatIconChevronUp
      onClick={onExpandHandler}
      className={styles['expander-icon']}
      size="lg"
      data-testid="expander-icon-close"
    />
  );
  const chevronDownIcon = (
    <CatIconChevronDown
      onClick={onExpandHandler}
      className={styles['expander-icon']}
      size="lg"
      data-testid="expander-icon-open"
    />
  );
  return (
    <div className={`${styles['expander-icon']} ${className}`}>
      <Conditional test={isExpanded} fallback={chevronDownIcon}>
        {chevronUpIcon}
      </Conditional>
    </div>
  );
};
